import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import GithubRepoCard from "../../components/githubRepoCard/GithubRepoCard";
import PublicationCard from "../../components/publicationsCard/PublicationCard";
import Button from "../../components/button/Button";
import TopButton from "../../components/topButton/TopButton";
import { Fade } from "react-reveal";
import {
  greeting,
  projectsHeader,
  publicationsHeader,
  majorProjects,
  publications,
} from "../../portfolio.js";
import ProjectsData from "../../shared/opensource/projects.json";
import "./Projects.css";
import ProjectsImg from "./ProjectsImg";

class Projects extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="projects-main">
        <Header theme={theme} />
        <div className="basic-projects">
          <Fade bottom duration={2000} distance="40px">
            <div className="projects-heading-div">
              <div className="projects-heading-img-div">
                {/* <img
											src={require(`../../assets/images/${projectsHeader["avatar_image_path"]}`)}
											alt=""
										/> */}
                <ProjectsImg theme={theme} />
              </div>
              <div className="projects-heading-text-div">
                <h1
                  className="projects-heading-text"
                  style={{ color: theme.text }}
                >
                  {projectsHeader.title}
                </h1>
                <p
                  className="projects-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {projectsHeader["description"]}
                </p>
              </div>
            </div>
          </Fade>
        </div>

        {/* Publications  */}
        {/* <h1>Technocrats</h1> */}

        <h1 className="majorprojects-header" style={{ color: theme.text }}>
          Major Projects
        </h1>

        {majorProjects.projects.map((project, index) => (
          <div class="majorProject" style={{ background: theme.highlight }}>
            <div key={index} className="majorProject-info">
              <h2 className="project-title" style={{ color: theme.text }}>
                {project.title}
              </h2>
              <p className="project-description">{project.description}</p>

              {/* {project.tools.length > 0 && (
                project.tools.map((tool, idx) =>
                    tool ? <h1 > {tool}</h1> : null
                  )
              )} */}

              {/* Project tools */}

              {(project.tools && project.tools.length > 0) > 0 && (
                <div>
                  <h3>Tools Used: {project.tools.join(", ")}</h3>
                </div>
              )}

              {/* Roles */}
              {project.roles && project.roles.length > 0 && (
                <div className="project-tools">
                  <h3>Roles :</h3>
                  <ul>
                    {project.roles.map((role, idx) =>
                      role ? <li key={idx}>{role}</li> : null
                    )}
                  </ul>
                </div>
              )}

              <a
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ background: theme.highlight }}
              >
                View App
              </a>
            </div>

            <div class="screenshots">
              <h3 style={{ color: theme.text }}>Screenshots </h3>
              {project.screenshots.length > 0 && (
                <div className="scroll-container">
                  {project.screenshots.map((screenshot, idx) =>
                    screenshot ? (
                      <img
                        key={idx}
                        src={require(`../../assets/projectSS/${screenshot}`)}
                        alt={`Screenshot ${idx + 1}`}
                        className="project-screenshot"
                      />
                    ) : null
                  )}
                </div>
              )}
            </div>
          </div>
        ))}

        <div className="repo-cards-div-main">
          {ProjectsData.data.map((repo) => {
            return <GithubRepoCard repo={repo} theme={theme} />;
          })}
        </div>
        <Button
          text={"More Projects"}
          className="project-button"
          href={greeting.githubProfile}
          newTab={true}
          theme={theme}
        />

        {/* Publications  */}
        {publications.data.length > 0 ? (
          <div className="basic-projects">
            <Fade bottom duration={2000} distance="40px">
              <div className="publications-heading-div">
                <div className="publications-heading-text-div">
                  <h1
                    className="publications-heading-text"
                    style={{ color: theme.text }}
                  >
                    {publicationsHeader.title}
                  </h1>
                  <p
                    className="projects-header-detail-text subTitle"
                    style={{ color: theme.secondaryText }}
                  >
                    {publicationsHeader["description"]}
                  </p>
                </div>
              </div>
            </Fade>
          </div>
        ) : null}

        <div className="repo-cards-div-main">
          {publications.data.map((pub) => {
            return <PublicationCard pub={pub} theme={theme} />;
          })}
        </div>

        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Projects;
